/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the patient summary component
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * React
 */
import * as React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


/**
 * Used to format text.
 */

/**
 * Used to style expanding areas.
 */

/**
 * Used to style expanding areas.
 */

/**
 * Used to style expanding areas.
 */





/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons/faExclamationCircle';
import List from '@material-ui/core/List';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { IPatient, useEventTypes, useFormTypes } from '@ngt/online-patient-management-ui';
import PatientSummaryEvents from './PatientSummaryEvents';


/*
 * ---------------------------------------------------------------------------------
 * interfaces
 * ---------------------------------------------------------------------------------
 */

interface IPatientSummaryListProps {
    patient: IPatient | null;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles<Theme>(theme => ({
    root: {
    }
}));

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */


const PatientSummaryList: React.FunctionComponent<IPatientSummaryListProps> = ({
    patient
}) => {
    const classes = useStyles();

    const [eventTypes, , eventTypesActions] = useEventTypes();
    const [formTypes, , formTypesActions] = useFormTypes();


    React.useEffect(() => {
        eventTypesActions.load();
        formTypesActions.load();

        return () => {
            eventTypesActions.clear();
            formTypesActions.clear();
        }
    }, [eventTypesActions, formTypesActions]);

    if (!patient) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={faExclamationCircle} fixedWidth />}
                severity="warning"
            >
                <AlertTitle>
                    No Patient
                </AlertTitle>
                No patient has been provided.
            </Alert>
        );
    }

    return (
        <List
            className={classes.root}
        >
            {
                eventTypes && patient && formTypes && eventTypes.map(eventType => {
                    return (
                        <PatientSummaryEvents
                            key={eventType.id}
                            patient={patient}
                            eventType={eventType}
                            formTypes={formTypes}
                        />
                    );
                })
            }
        </List>
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default PatientSummaryList;
